import React, { useEffect, useState } from "react";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import { Row, Col, Progress } from "reactstrap";
import "../HCDashboard.scss";

const QUERY = gql`
  {
    getDataDashboardReimbursement {
      total_reimbursement
      reimbursement_this_month
      reimbursement_last_month
      reimbursement_this_year
      reimbursement_last_year
    }
  }
`;

const GETREIMLIST = gql`
  query getEmployeeReimbursementAll(
    $user_code: String
    $start: String
    $end: String
    $status: String
    $page: Int
  ) {
    getEmployeeReimbursement(
      user_code: $user_code
      start: $start
      end: $end
      status: $status
      page: $page
    ) {
      count
      rows {
        id
        user_code
        request_date
        request_type
        amount_requested
        approved
        approved_by
        approval_date
        amount_accepted
        approval_remark
        user_profile {
          first_name
          middle_name
          last_name
        }
        user_approved {
          first_name
          middle_name
          last_name
        }
        proof {
          proof_name
          filename
        }
        AP {
          transaction_code
        }
      }
    }
  }
`;

function numFormat(number) {
  if (number !== 0)
    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
  return number;
}

const Reimbursement = (props) => {
  let responbility = JSON.parse(localStorage.getItem("_dentonslogin"));

  const { data, error, loading, refetch } = useQuery(QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const {
    refetch: allReimbursement,
    error: errorAllReimbursement,
    data: dataAllReimbursemet,
    loading: loadingAllReimbursement,
  } = useQuery(GETREIMLIST, {
    variables: {
      user_code: responbility.user_code === "HC" ? " " : responbility.user_code,
      start: "",
      end: "",
      status: "",
      page: 1,
    },
    fetchPolicy: "cache-and-network",
  });

  const [mounthPercentage, setMounthPercentage] = useState(0);
  const [YearPercentage, setYearPercentage] = useState(0);
  useEffect(() => {
    if (data) {
      let mount =
        ((data.getDataDashboardReimbursement.reimbursement_this_month -
          data.getDataDashboardReimbursement.reimbursement_last_month) /
          data.getDataDashboardReimbursement.reimbursement_last_month) *
        100;
      let year =
        ((data.getDataDashboardReimbursement.reimbursement_this_year -
          data.getDataDashboardReimbursement.reimbursement_last_year) /
          data.getDataDashboardReimbursement.reimbursement_last_year) *
        100;
      setMounthPercentage(mount);
      setYearPercentage(year);
    }
  }, [data]);
  return (
    <>
      <div className="section p5">
        <div className="sectioncontent">
          <h5 className="blocktext">Reimbursement</h5>
          <Row className="cardHC">
            <Col>
              <div className="total">
                <div className="nth1">
                  <i className="fa fa-compress"></i>
                </div>
                <div className="nth2">
                  <div>
                    <span>Reimbursement Total</span>
                  </div>
                  <div>
                    <h4>
                      Rp.&nbsp;
                      {numFormat(
                        data
                          ? data.getDataDashboardReimbursement
                              .total_reimbursement
                          : 0
                      )}
                    </h4>
                  </div>
                </div>
                <div className="nth3"></div>
              </div>
            </Col>
            <Col>
              <div className="this-year">
                <div className="nth1">
                  <i className="fa fa-check-circle"></i>
                </div>
                <div className="nth2">
                  <div className="nth1-year">
                    <div>
                      <span>This Mounth</span>
                    </div>
                    <div>
                      <h5>
                        Rp. &nbsp;
                        {numFormat(
                          data
                            ? data.getDataDashboardReimbursement
                                .reimbursement_last_month
                            : 0
                        )}
                      </h5>
                    </div>
                  </div>
                  <div className="nth2">
                    <Progress
                      value={
                        isNaN(mounthPercentage.toFixed(2))
                          ? 0
                          : mounthPercentage.toFixed(2)
                      }
                      color="secondary"
                    >
                      <span className="text-dark">
                        <span className="text-dark">
                          {isNaN(mounthPercentage.toFixed(2))
                            ? 0
                            : mounthPercentage.toFixed(2)}
                          %
                        </span>
                        &nbsp; Usage
                      </span>
                    </Progress>
                  </div>
                </div>
              </div>
            </Col>
            <Col>
              <div className="this-year">
                <div className="nth1">
                  <i className="fa fa-check-circle"></i>
                </div>
                <div className="nth2">
                  <div className="nth1-year">
                    {" "}
                    <div>
                      <span>This Year</span>
                    </div>
                    <div>
                      <h5>
                        {" "}
                        Rp.&nbsp;
                        {numFormat(
                          data
                            ? data.getDataDashboardReimbursement
                                .reimbursement_this_year
                            : 0
                        )}
                      </h5>
                    </div>{" "}
                  </div>
                  <div className="nth2">
                    <Progress
                      value={
                        data
                          ? data.getDataDashboardReimbursement
                              .reimbursement_last_year === 0
                            ? 0
                            : YearPercentage
                          : 0
                      }
                      color="secondary"
                    >
                      <span className="text-dark">
                        <span className="text-dark">
                          {data
                            ? data.getDataDashboardReimbursement
                                .reimbursement_last_year === 0
                              ? 0
                              : YearPercentage
                            : 0}
                          %
                        </span>
                        &nbsp; Usage
                      </span>
                    </Progress>
                  </div>
                </div>
              </div>
            </Col>
            <Col md="12">
              <div className="py-3">
                <h5>Last Request</h5>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Request Type</th>
                      <th scope="col">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataAllReimbursemet ? (
                      dataAllReimbursemet.getEmployeeReimbursement.rows.length >
                      0 ? (
                        dataAllReimbursemet.getEmployeeReimbursement.rows.map(
                          (x, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  {x.user_profile.first_name}&nbsp;
                                  {x.user_profile.middle_name}&nbsp;
                                  {x.user_profile.last_name}
                                </td>
                                <td>{x.request_type}</td>
                                <td>Rp. {numFormat(x.amount_requested)}</td>
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan="3">
                            <div className="text-center">
                              <img
                                src={require("../../../../images/nodatamin.png")}
                                className="w-25 m-auto"
                              />
                              {/* <h5 className="text-muted">No Data Request</h5> */}
                            </div>
                          </td>
                        </tr>
                      )
                    ) : (
                      []
                    )}
                  </tbody>
                </table>
                <div className="text-center">
                  {dataAllReimbursemet ? (
                    dataAllReimbursemet.getEmployeeReimbursement.rows.length >
                    5 ? (
                      <a
                        href="#/HC/reimbursement_list"
                        className="btn btn-link"
                      >
                        {" "}
                        Show More
                      </a>
                    ) : null
                  ) : (
                    []
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Reimbursement;
